import { useDispatch, useSelector } from "react-redux";
import {
  getDepartureFiltersOptions,
  getReturnFiltersOptions,
  getStopsOption,
  getMaxPriceFilter,
  getFareclassOptionFilter,
  getAirlineFilter,
  getHasSetStopsOption,
  getHasSetFareClassFilter,
  getHasSetAirlineFilter,
  hasSetMaxPriceFilterSelector,
  setFareclassOptionFilter,
  setStopsOption,
  setMaxPriceFilter,
  setAirlineFilter,
  initialFareclassOptionFilter,
} from "@b2bportal/core-flights";
import {
  type FareclassOptionFilter,
  SliceStopCountFilter,
} from "@b2bportal/core-types";
import type { FilterPriceValue } from "@b2bportal/core-ui";
import { trackAppliedFilter, FilterType } from "@/utilities/tracking";

export const useFilterList = (sliceIndex: number) => {
  const dispatch = useDispatch();
  const departureFilterOptions = useSelector(getDepartureFiltersOptions);
  const returnFilterOptions = useSelector(getReturnFiltersOptions);

  const filterOptions =
    sliceIndex === 0 ? departureFilterOptions : returnFilterOptions;

  /** State data  */
  const stopsState = useSelector(getStopsOption);
  const priceState = useSelector(getMaxPriceFilter);
  const fareClassesState = useSelector(getFareclassOptionFilter);
  const airlineFilter = useSelector(getAirlineFilter);

  //   const hadSetFilters = useSelector(hasSetFiltersSelector);
  const hadSetStopsFilter = useSelector(getHasSetStopsOption);
  const hadSetFareClassFilter = useSelector(getHasSetFareClassFilter);
  const hadSetAirlineFilter = useSelector(getHasSetAirlineFilter);
  const hadSetPriceFilter = useSelector(hasSetMaxPriceFilterSelector);

  /** Handle filters */
  const handleFilterFareClasses = (fareClasses: FareclassOptionFilter) => {
    dispatch(setFareclassOptionFilter(fareClasses));
    trackAppliedFilter(FilterType.FARECLASS);
  };

  const handleFilterStopUpdate = (stopOption: SliceStopCountFilter) => {
    dispatch(setStopsOption(stopOption));
    trackAppliedFilter(FilterType.STOPS);
  };

  const handleFilterPriceUpdate = ({ maxPrice }: FilterPriceValue) => {
    dispatch(setMaxPriceFilter(maxPrice));
    trackAppliedFilter(FilterType.PRICE);
  };

  const handleAirlineFilterChange = (airlines: string[]) => {
    dispatch(setAirlineFilter(airlines));
    trackAppliedFilter(FilterType.AIRLINE);
  };

  const resetFareClassFilter = () => {
    dispatch(setFareclassOptionFilter(initialFareclassOptionFilter));
  };

  const resetStopFilter = () => {
    dispatch(setStopsOption(SliceStopCountFilter.ANY_NUMBER));
  };

  const resetAirlineFilter = () => {
    dispatch(setAirlineFilter([]));
  };

  const resetPriceFilter = () => {
    dispatch(setMaxPriceFilter(Number.MAX_SAFE_INTEGER));
  };

  return {
    context: {
      stopsState,
      priceState,
      fareClassesState,
      airlineFilter,
      hadSetStopsFilter,
      hadSetFareClassFilter,
      hadSetAirlineFilter,
      hadSetPriceFilter,
      filterOptions,
    },
    handlers: {
      handleFilterFareClasses,
      handleFilterStopUpdate,
      handleFilterPriceUpdate,
      handleAirlineFilterChange,
      resetFareClassFilter,
      resetStopFilter,
      resetAirlineFilter,
      resetPriceFilter,
    },
  };
};
